{
  "nav": {
    "read": "Lire",
    "write": "Écrire",
    "about": "À propos",
    "me": "Moi"
  },
  "letter": {
    "by": "Par",
    "writtenOn": "Écrit le",
    "inResponseTo": "En réponse à",
    "when": "Quand ?",
    "about": "À propos ?",
    "approvedBy": "Approuvée par",
    "sources": "Sources ?",
    "status": "Statut",
    "byAuthor": "par {{name}}",
    "contribute": "Contribuer",
    "noLetterYet": "Il n'y a pas encore de lettre.",
    "responses_one": "{{count}} réponse",
    "responses_other": "{{count}} réponses",
    "respond": "Répondre à ce message"
  },
  "write": {
    "workspaceTitle": "Écrire",
    "workspaceHint": "Vos brouillons et lettres en relecture.",
    "newLetter": "+ Nouvelle lettre"
  },
  "editor": {
    "title": "Titre",
    "text": "Texte",
    "sources": "Sources (une URL par ligne)",
    "sourcesPlaceholder": "https://exemple.org/article\nhttps://autre-source.fr/ressource",
    "saveDraft": "Enregistrer en brouillon",
    "sendForReview": "Envoyer en relecture",
    "saving": "Enregistrement…",
    "submitting": "Envoi…",
    "savedDraft": "Brouillon enregistré.",
    "sentForReview": "Lettre envoyée en relecture.",
    "saveFailed": "Impossible d'enregistrer la lettre.",
    "submitFailed": "Impossible d'envoyer la lettre en relecture.",
    "statusRejected": "Rejetée",
    "wordsLeft": "{{count}} mots restants"
  },
  "review": {
    "prompt": "Cette lettre attend votre relecture.",
    "approve": "Approuver",
    "reject": "Rejeter",
    "rejectPrompt": "Pour quelle raison rejetez-vous cette lettre ? (l'auteur lira votre commentaire)",
    "notifyVoteRecorded": "Votre vote a été enregistré.",
    "notifyPublished": "Lettre publiée — le seuil d'approbations est atteint.",
    "notifyRejected": "Lettre renvoyée à l'auteur — le seuil de rejets est atteint.",
    "failed": "Impossible d'enregistrer votre vote."
  },
  "limit": {
    "todayLabel": "Aujourd'hui",
    "actions": "{{used}}/{{max}} actions"
  },
  "closed": {
    "title": "Le réseau est fermé",
    "subtitle": "Les écritures sont en pause de 22h à 7h dans votre fuseau horaire.",
    "comeBack": "Revenez après 7h pour écrire."
  },
  "about": {
    "title": "A kind network",
    "subtitle": "Relu par les pairs, fédéré, post-croissance",
    "keyElementsTitle": "Règles du jeu",
    "items": {
      "perDay": { "title": "17 par jour", "body": "Maximum 17 actions par jour, comme les 17 syllabes d'un haïku." },
      "noScroll": { "title": "Pas de scroll", "body": "On lit un texte à la fois, suivi des réponses." },
      "peerReviewed": { "title": "Validé par les pairs", "body": "La modération se fait a priori, par les pairs." },
      "sourced": { "title": "Sourcé", "body": "Les textes sont présentés et annotés avec contexte & références." },
      "singleFeatured": { "title": "Mono-fonctionnel", "body": "Pas de job board, de quiz, etc. Juste un lieu de discussion." },
      "noAds": { "title": "Sans publicité", "body": "Un réseau communautaire, libre et open source." },
      "interoperable": { "title": "Interopérable", "body": "Infrastructure ouverte et standard." },
      "nig": { "title": "NIG compliant", "body": "S'inscrit dans le cadre de référence NIG pour un Numérique d'Intérêt Général." },
      "collective": { "title": "Conçu pour l'intelligence collective", "body": "Constructif, respectueux et lent." }
    },
    "pillarsTitle": "Structure",
    "pillars":{
      "who": {
        "title": "Quelle personne ?",
        "sub": "Ce que je suis",
        "detail": "D'où je parle ? Quelles sont mes croyances ? Quelles sont mes opinions ?"
      },
      "what": {
        "title": "Quel propos ?",
        "sub": "Ce que je dis",
        "detail": "À propos de quoi ? Sur quel thème ? Dans quel temps ?"
      },
      "proof": {
        "title": "Quelles preuves ?",
        "sub": "Ce que je sais",
        "detail": "Les sources, la traçabilité, les précisions contextuelles (fact-checking)"
      }
    },
    "credits":{
      "title": "Crédits",
      "text": "Design : Arnaud Levy + Nicolas Pariès + Anthony Ferretti. <br>Logotype : Arnaud Levy. <br>Développement : noesya. <br>Typographies : Adelphe Floréal, Bricolage Grotesque. <br>Code source : <a href=\"http://github.com/noesya/akindnetwork/\" target=\"_blank\">github.com/noesya/akindnetwork/</a>. <br>Hébergement : Infomaniak. <br>Stack : ActivityPods."
    }
  },
  "me": {
    "title": "Moi",
    "drafts": "Brouillons",
    "inReview": "En relecture",
    "published": "Publiées",
    "emptyDrafts": "Aucun brouillon pour l'instant.",
    "untitledDraft": "Sans titre",
    "emptyReview": "Aucune lettre en relecture pour l'instant.",
    "emptyPublished": "Aucune lettre publiée pour l'instant.",
    "status": {
      "draft": "Brouillon",
      "inReview": "En relecture",
      "published": "Publiée"
    },
    "languageLabel": "Langue",
    "account": "Compte",
    "connectPod": "Connecter mon Pod",
    "connectPodDisabled": "Auth non configurée — mode démo",
    "logout": "Déconnexion"
  },
  "login": {
    "title": "Connecter mon Pod",
    "hint": "Saisissez l'adresse de votre fournisseur de Pod ActivityPods.",
    "podProvider": "Fournisseur de Pod",
    "connect": "Connecter",
    "connecting": "Redirection…",
    "cancel": "Annuler",
    "back": "Retour",
    "finishing": "Connexion en cours…",
    "error": "Erreur de connexion",
    "unconfigured": "L'authentification n'est pas encore configurée. Renseignez VITE_FRONTEND_URL dans le .env pour activer le login Solid."
  },
  "language": {
    "switch": "EN"
  },
  "demo": {
    "banner": "Données d'exemple — vous explorez la maquette.",
    "connect": "Connecter mon Pod",
    "disabledHint": "Connectez votre Pod pour enregistrer."
  },
  "user": {
    "publishedLetters": "Lettres publiées",
    "noLetters": "Cette personne n'a pas encore publié de lettre."
  },
  "source": {
    "open": "Ouvrir la source"
  }
}
